import {Filters} from '../../_flux/constants/filter/filters';
import {
    setValuesAction,
    setTyreOptionsAction,
    enableButtonConfirmAction,
} from '../../_flux/actions/rego_lookup_actions';

export function onSelectVehicle(values) {
    $('.rego-lookup-vehicle-data').removeClass('rego-lookup-vehicle-data-selected');
    $('#vehicle-' + values[Filters.VEHICLE_ID]).addClass('rego-lookup-vehicle-data-selected');

    const tyreOptions = values[Filters.VEHICLE_TYRES];
    setTyreOptionsAction(tyreOptions);
    setValuesAction({
        ...values, [Filters.VEHICLE_TYRES]: ''
    });
    enableButtonConfirmAction();
}
